import { useState } from "react";

import { Radio, RadioGroup } from "@/design-system/components/Radio/Radio";
import useFeatureFlags from "@/hooks/useFeatureFlag";
import { useHasSessionReplayHeatmapsEntitlement } from "@/sessionReplay/useHasSessionReplayHeatmapsEntitlement";

import { getRoleOptions } from "./roleOptions";

type RoleSelectorProps = {
  defaultRole: string;
  onRoleChange: (role: string) => void;
};

function RoleSelector({ defaultRole, onRoleChange }: RoleSelectorProps) {
  const flag = useFeatureFlags();
  const { hasEntitlement } = useHasSessionReplayHeatmapsEntitlement();
  const [selectedRole, setSelectedRole] = useState(defaultRole);

  return (
    <div className="space-y-2">
      <p className="font-bold">Role</p>
      <RadioGroup
        value={selectedRole}
        name="role-select"
        onValueChange={(value) => {
          setSelectedRole(value);
          onRoleChange(value);
        }}
      >
        {getRoleOptions().map((roleOption) => (
          <Radio
            key={roleOption.value}
            value={roleOption.value}
            label={roleOption.label}
            description={roleOption.description(flag, hasEntitlement)}
          />
        ))}
      </RadioGroup>
    </div>
  );
}

export default RoleSelector;
